// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d70f57b9","977":"d40e98da"}[chunkId] + ".chunk.js";
};